export default "__VITE_ASSET__04f5c714__"